
import {Options, Vue} from 'vue-class-component';
import {Appointment} from "@/data/appointments";
import NavigationService from "@/services/NavigationService";
import AuthService from "@/services/AuthService";
import EventBusService from "@/services/EventBusService";
import ProfileRegionCredits from "@/components/ProfileRegionCredits.vue";
import RegionProducts from "@/components/RegionProducts.vue";
import ProfileAvatarUpload from "@/components/ProfileAvatarUpload.vue";
import {RecordIdentifier} from "@/data/global";
import {Region} from "@/data/region";
import {UserProfile} from "@/data/profile";
import UserCourses from "@/components/UserCourses.vue";
import UserCoursesArchive from "@/components/UserCoursesArchive.vue";
import apiConfig from "@/config/api";
import ProfileEditModal from "@/components/modals/ProfileEditModal.vue";
import ProfileDeleteModal from "@/components/modals/ProfileDeleteModal.vue";
import VoucherRedemptionModal from "@/components/modals/VoucherRedemptionModal.vue";
import UserOrdersModal from "@/components/modals/UserOrdersModal.vue";
import UnusedTrialCreditAlert from "@/components/alerts/UnusedTrialCreditAlert.vue";
import AppointmentsCalendar from "@/components/AppointmentsCalendar.vue";
import RegionService from "@/services/RegionService";
import {filterAppointments} from "@/utils/filter";
import {CoursesFilterEvent} from "@/data/eventbus";


type RegionState = {
    _collapsed: boolean,
    _initialized: boolean,
}

type RegionWithState = Region & RegionState;

type UserProfileWithRegions = UserProfile & {
    regions: Array<RegionWithState>,
};

@Options({
    props: {
        /*preselectRegion: {
            type: Number,
            required: false,
            default: null,
        }*/
    },
    components: {
        AppointmentsCalendar,
        UnusedTrialCreditAlert,
        VoucherRedemptionModal,
        ProfileEditModal,
        ProfileDeleteModal,
        UserOrdersModal,
        UserCourses,
        UserCoursesArchive,
        ProfileRegionCredits,
        RegionProducts,
        ProfileAvatarUpload,
    },
})
export default class Profile extends Vue {
    //preselectRegion?: number|null
    loading = true
    loaded = false

    regionId: number | null = null

    archiveShown = false

    appointmentsRaw: Appointment[] = []

    profile: UserProfileWithRegions = {
        role: 0,
        role_label: '',
        prename: '',
        surname: '',
        email: '',
        email_verified: false,
        phone_mobile: '',
        avatar_url: null,
        consent_newsletter: false,
        regions: [],
    }

    profileEditModalShown = false

    openProfileEditModal() {
        this.profileEditModalShown = true;
    }

    closeProfileEditModal() {
        this.profileEditModalShown = false;
    }

    profileDeleteModalShown = false

    openProfileDeleteModal() {
        this.profileDeleteModalShown = true;
    }

    closeProfileDeleteModal() {
        this.profileDeleteModalShown = false;
    }

    voucherRedemptionModalShown = false

    openVoucherRedemptionModal() {
        this.voucherRedemptionModalShown = true;
    }

    closeVoucherRedemptionModal() {
        this.voucherRedemptionModalShown = false;
    }

    userOrdersModalShown = false

    openUserOrdersModal() {
        this.userOrdersModalShown = true;
    }

    closeUserOrdersModal() {
        this.userOrdersModalShown = false;
    }

    onVoucherRedeemed() {
        // this.loadProfile(); // @TODO: we do nothing here? is that correct?
    }

    loadAppointments(): Promise<Appointment[]> {
        if (!this.regionId) {
            this.loaded = true;
            return Promise.resolve([]);
        }

        return RegionService.getRegionAppointments(this.regionId as number)
            .then(result => {
                this.appointmentsRaw = result.data.data || [];
                this.loaded = true;
                return this.appointmentsRaw;
            })
            .finally(() => this.loading = false);
    }

    get appointments(): Appointment[] {
        return this.appointmentsRaw;
    }

    get assetsBaseUrl() {
        return apiConfig.frontendAssetsUrl;
    }
    loadProfile() {
        this.loading = true;
        return AuthService.getAuthUser()
            .then(result => {
                this.profile = result.data.data;
                this.profile.regions = this.profile.regions.map(region => ({
                    ...region,
                    _collapsed: true,
                    _initialized: false,
                }));
                if (this.profile.regions.length === 1) {
                    this.profile.regions[0]._collapsed = false;
                    this.profile.regions[0]._initialized = true;
                }

                this.regionId = this.profile.regions.length ? this.profile.regions[0].id : null;

                // Load appointments after profile is fetched
                this.loadAppointments();
            })
            .finally(() => this.loading = false);
    }

    toggleRegion(region: RegionWithState) {
        region._collapsed = !region._collapsed;
        region._initialized = true;
        if (!region._collapsed) {
            this.regionId = region.id;
            this.loadAppointments();
        }
    }

    performLogout() {
        (window as any).buggyFitLogout();
        setTimeout(() => {
            NavigationService.navigateLogoutSuccessful();
        }, 600);
    }

    openAvatarFileSelector() {
        EventBusService.$emit('user.profile.avatar.openFileSelector');
    }

    onProfileUpdated(data: Record<string, any>) {
        Object.entries(data || {}).forEach(([key, value]) => {
            if (typeof this.profile[key as keyof UserProfileWithRegions] !== 'undefined') {
                this.profile[key as keyof UserProfileWithRegions] = value as never;
            }
        })
    }

    onProfileDelete() {
        setTimeout(() => {
            this.performLogout();
        }, 3000);
    }

    onRegionContactFormClicked(regionId: RecordIdentifier) {
        EventBusService.$emit('modals.region.contact.open', {region: regionId});
    }

    showArchive() {
        this.archiveShown = true;
    }

    mounted() {
        this.loadProfile();
    }
}
